import React from 'react';
/**
 * We're using Dialog directly from material UI as we need to customize the positioning
 * and our Modal component doesn't provide this yet.
 */
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material/styles';
import type { FC } from 'react';
import styled from '@emotion/styled';

import type { ModalProps } from '../../ui/Modal/Modal';
import BackButton from '../../ui/BackButton/BackButton';
import noop from '../../utils/function/noop';
import { TITLE_IDS } from '../../utils/element-ids';

import HelpContent from './components/HelpContent';

type HelpModalProps = {
  open: boolean;
  onClose?: ModalProps['onClose'];
};

const HelpModal: FC<HelpModalProps> = ({
  open,
  onClose = noop,
}) => {
  const theme = useTheme();

  const StyledModalRoot = styled(Dialog)({
    position: 'absolute !important' as any,
    '& .ccg-MuiDialogContent-root:first-of-type': {
      paddingTop: '0px',
    },
  });

  const StyledHelpContentRoot = styled(DialogContent)({
    padding: theme.spacing(3),
    paddingTop: 0,
  });
  return (
    <StyledModalRoot
      open={open}
      container={document.getElementById('contentRoot')}
      PaperProps={{
        elevation: 0,
        margin: 0, // alternative to replace paperRoot class
      }}
      hideBackdrop
      fullScreen
      fullWidth
      scroll="body"
      aria-labelledby={TITLE_IDS.HELP_MODAL_TITLE_ID}
      aria-describedby="helpModalContentContainer"
    >
      <StyledHelpContentRoot id="helpModalContentContainer">
        <BackButton
          onClick={() => {
            onClose();
          }}
          label="Back"
        />
        <HelpContent />
      </StyledHelpContentRoot>
    </StyledModalRoot>
  );
};

export default HelpModal;
